import React, { useContext, useMemo, useEffect, useState } from "react";
// import { FiBriefcase } from "react-icons/fi";
import { FaRegUserCircle, FaBriefcase } from "react-icons/fa";
import { listFormat, capitalizeWords,currentLang } from "utils/utils";
import VerifyIconSVG from "assets/svg/verified-icon";
import { useHistory, useParams } from "react-router-dom";
import _ from "lodash";
import { Context } from "context/context";
import { TbWorld } from "react-icons/tb";
import ToolTip from "components/tootltip/tootltip";
import { useTranslation } from "react-i18next";

export default function ProfileDetails({ data = {}, isYourProfile = false, userData={},socMed=[] }) {
  const {translation={}, profile_name=null, other_name=null} = data;
  const lang = currentLang();
  const { t } = useTranslation();
  const history = useHistory();
  const { username, profileId } = useParams();
  const { following, followers } = useContext(Context);

  const { http } = global.services;
  const [socialMedias, setSocialMedias] = useState([]);
  const occupation = useMemo(() => {
    if (data && data.occupations && data.occupations.length > 0) {
      var capitalizedArray = data.occupations.map(capitalizeWords);
      const list = capitalizedArray.map((o) => {
        if (typeof o === "object") {
          return translation?.[lang]?.[o.value] || o.value;
        } else if (typeof o === "string") {
          return translation?.[lang]?.[o] || o;
        } else {
          return null;
        }
      });

      if (list) {
        const currLang = lang === 'ch' ? 'zh-cn' : lang;
        if(currLang !== 'undefined') { 
          return listFormat(list,currLang);
        }else{
          return listFormat(list,'en');
        }
      }
    }
    return "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.occupations,lang]);

  useEffect(() => {
    if (!_.isEmpty(socMed)) {
      setSocialMedias((prev) => {
        return prev.map((socialMed) => {
          const updated = socMed.find(newSocMed => newSocMed.id === socialMed.id);
          if (updated) {
            return {
              ...socialMed,
              translation: {
                ...socialMed.translation,
                ...updated.translation
              }
            };
          } else {
            return socialMed;
          }
        });
      });
    }
  }, [socMed]);



  const getSocialMedias = async () => {
    if (!_.isEmpty(data)) {
      try {
        const socialMedias = await http.get("public/social-medias", {
          user_profile_id: data.id,
        });
        setSocialMedias(socialMedias.data.social_media);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const websiteOnly = useMemo(() => {
    let mappedData = [];
    if (!_.isEmpty(socialMedias)) {
      socialMedias.forEach((socialMedia) => {
        if (socialMedia?.media_type === "website") {
          mappedData.push(socialMedia);
        }
      });
    }
    return mappedData.sort((a,b) => a.order - b.order);
  }, [socialMedias]);

  useEffect(() => {
    getSocialMedias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.id]);

  const pushFollowing = () => {
    history.push({
      pathname: `/${username}/profile/${profileId}/following`,
      state: { useData: data },
    });
  };

  const display_name = () => {
    if (data?.displayName) {
      switch (data?.displayName) {
        case "First Name":
          return data?.user?.first_name;
        case "Surename":
          return data?.user?.last_name;
        case "Other Name":
          return data?.user?.other_name || data?.other_name;
        case "Username":
          return data?.user?.username;
        case "First Name Surname":
          return `${data?.user?.first_name} ${data?.user?.last_name}`;
        default:
          return data?.user?.other_name || data?.other_name;
      }
    } else {
      return data?.user?.username;
    }
  };

  const notFullName = (profile_name, user) => {
    const fullName = `${user?.first_name} ${user?.last_name}`;

    const contains = !!profile_name?.toLowerCase()
      .includes?.(fullName.toLowerCase());

    const contains2 = !!fullName
      .toLowerCase()
      .includes?.(profile_name?.toLowerCase());

    if (profile_name?.toLowerCase() !== fullName.toLowerCase()) {
      if (contains || contains2) {
        return false;
      }

      return true;
    } else {
      return false;
    }
  };

  const isNotFullName = notFullName(data.profile_name, data?.user);

  return (
    <div className="text-center 3md:text-left">
      <h2 className="text-2xl 2sm:text-2.5xl 3md:text-5xl 3md:mt-0  text-lightBlack tracking-tighter 3md:leading-58 font-bold flex flex-row items-center justify-center 2sm:justify-start name-header-name break-name">
        {/* <>{display_name(data) || data?.user?.username}</> */}
        <>{(translation?.[lang]?.[profile_name] || data?.profile_name) ||
         (translation?.[lang]?.[other_name] || data?.other_name) || 
         (translation?.[lang]?.[data?.user?.username] || data?.user?.username) }</>
        {data?.id3_verified && (
          <VerifyIconSVG className="w-5 h-5 3md:w-7 3md:h-7 ml-1 3md:ml-2.5" />
        )}
      </h2>
      <div className="text-[14px] 2sm:text-sm 3md:text-base flex mt-1 3md:mt-0 justify-center 2sm:justify-start text-lightBlack space-x-2 2sm:space-x-0 leading-6 border-b border-gray pb-3 2sm:pb-3.5 flex-wrap name-header-username">
        {!_.isEmpty(data?.username) && (
          <>
            <p className="text-primary font-[500] sm:hidden sm:block">
              @{translation?.[lang]?.[data?.username] || data?.username}
            </p>
          </>
        )}
        {!_.isEmpty(data?.user) && (
          <>
            <div className="flex items-center name-header">
              {!_.isEmpty(data?.username) && (
                <>
                  <p className="text-primary font-[500] hidden sm:block">
                    @{translation?.[lang]?.[data?.username] || data?.username}
                  </p>
                </>
              )}


              {(isNotFullName) && (
                <>
                  <p className="text-passwordGray hidden sm:block">•</p>
                  <span className={`font-semibold ${data?.profile_type?.type !== 'personal' || data?.profile_type?.type !== 'character' ? 'pr-1' : 'pr-0'}`}>{(data?.profile_type?.type === 'personal' || data?.profile_type?.type === 'character')?"":"Created by"}</span>
                </>
              )}
                
              {isNotFullName && (
                <>
                  <span>
                    {translation?.[lang]?.[data.user.first_name] ||
                     data.user.first_name}{" "}
                    {translation?.[lang]?.[data.user.last_name] || data.user.last_name}
                  </span>

                  {data.id3_verified && (
                    <span className="pr-1">
                      <VerifyIconSVG className="w-3 h-3 3md:w-3 3md:h-3 ml-[2px]" />
                    </span>
                  )}
                </>
              )}
              
              {!!data?.other_name && (
                <>
                  <p className="text-passwordGray">•</p>
                  <span> aka {translation?.[lang]?.[data.other_name] || data.other_name}</span>
                </>
              )}
            
              {/* {data?.other_names && (
                                <>
                                    <span className="px-1">/</span>
                                    {data?.other_names.map((p, i) => (
                                        <span className="" key={i}>
                                            {p.label}
                                            {i < data?.other_names.length - 1 &&
                                                " / "}
                                        </span>
                                    ))}
                                </>
                            )} */}
              { (data?.profile_type?.type === 'personal' || data?.profile_type?.type === 'character') &&
                <>
                  {!_.isEmpty(data?.gender) && (
                    <>
                      <p className="text-passwordGray">•</p>
                      <p>{translation?.[lang]?.[data.gender] || data.gender}</p>
                    </>
                  )}

                  {/* Then pronoun */}
                  {!_.isEmpty(data?.pronoun) && (
                    <>
                      <p className="text-passwordGray">•</p>
                      <p>{translation?.[lang]?.[data.pronoun]  || data.pronoun}</p>
                    </>
                  )}
                </>
              }
                {!_.isEmpty(data?.address) && 
                  <>
                    <p className="text-passwordGray">&#8226;</p>
                    <p>{translation?.[lang]?.[data.address] || data?.address}</p>
                  </>
                }
            </div>{" "}
          </>
        )}
      </div>
      <div className="mt-3.5 flex justify-start 3md:block">
        <ul className="text-lightBlack text-[14px] 2sm:text-sm 3md:text-base leading-5 grid gap-y-1 3md:gap-y-2.5">
          {!_.isEmpty(occupation) && (
            <li className="flex justify-start">
              <FaBriefcase className="text-darkerGray mr-1.5 3md:mr-3 mt-1" />
              <p className="w-full text-left">{occupation}</p>
            </li>
          )}
          {!_.isEmpty(data?.profile_type?.type) && (
            <li className="flex justify-start items-center">
              <FaRegUserCircle className=" text-lg text-darkerGray mr-1.5 3md:mr-3" />
              {/* Character */}
              <div className="w-full flex justify-start flex-row gap-x-1.5 items-center">
                <p>{t(data?.profile_type?.type) || _.upperFirst(data?.profile_type?.type)}</p>
              </div>
            </li>
          )}
          {!_.isEmpty(websiteOnly) && (
            <li className="flex justify-start items-center">
              <TbWorld className="text-lg text-darkerGray mr-1.5 3md:mr-3" />
              <div className="flex space-x-1 flex-wrap">
                {websiteOnly.map((socialMedia, i) => {
                  let counter = i + 1;
                  return (
                    <React.Fragment key={i}>
                      <ToolTip value={socialMedia.link} arrowClass="top-[23px]">
                        <a style={{ color: "#0c6ed1" }} href={socialMedia.link} target="_blank" rel="noreferrer">
                          {(socialMedia?.translation?.[lang]?.[socialMedia.label] || socialMedia.label) || socialMedia.type}
                        </a>
                      </ToolTip>
                      {counter < websiteOnly.length ? (
                        <p className="text-passwordGray">&#8226;</p>
                      ) : (
                        <></>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </li>
          )}
        </ul>
      </div>
      {/* {data?.user?.username && isYourProfile && ( */}
      {(!_.isEmpty(data) && !_.isEmpty(userData) && (data?.followers) || isYourProfile) ? (
        <div className="mt-1 3md:mt-4.5 flex justify-start 3md:justify-center 3md:block text-[14px] 2sm:text-sm 3md:text-base">
          <div className="flex flex-row space-x-2.5 text-lightBlack">
            {followers.length > 0 ? (
              <p className="cursor-pointer" onClick={pushFollowing}>
                <span className="font-bold">{_.size(followers)}</span>{" "}
                {/* Mutual Connection{_.size(following)>1?"s":""} */}
                {/* {t("mutualConnections", { // not working arabic
                  count: _.size(following) <= 1 ? 1 : _.size(following),
                })} */}
                {_.size(followers)>1? t('followers'):t('follower')}

              </p>
            ):
              following.length > 0 &&
              (
                <>
                {/* <p className="opacity-30">&#8226;</p> */}
                <p className="cursor-pointer" onClick={pushFollowing}>
                    <span className="font-bold">
                        {_.size(following)}
                    </span>{" "}
                    {t('following')}
                </p>
                </>
              )
              
          }
            
          </div>
        </div>
      ):
      <></>
      }
      {/* )} */}
    </div>
  );
}
